const data = {
    productItems:[
        {
            id: '1',
            product: 'Doughnuts',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo2.jpg',
            category:'Dairy'
        }
        /*,
        {
            id: '2',
            product: 'Cake',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Dairy'
        },
        {
            id: '3',
            product: 'Bread',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Dairy'
        },
        {
            id: '4',
            product: 'Bengin',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Vegetables'
        },
        {
            id: '5',
            product: 'Chiken',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Meats'
        },
        {
            id: '6',
            product: 'Grapes',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Fruits'
        },
        {
            id: '7',
            product: 'Wheat',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Grains'
        },
        {
            id: '8',
            product: 'Milk',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Bakery'
        },
        {
            id: '9',
            product: 'Lights',
            count: '20000',
            points: '10',
            available: '20',
            limit: '6',
            bestusedby: '10/31/2021',
            image: './../images/logo.png',
            category:'Electronics'
        }*/
    ]
}

export default data;